module.exports = __webpack_public_path__ + "img/banner_3.2fa684fe.jpg";